<template>
  <div class="c-serviceSearchHeaderFacetTabs">
    <ServiceSearchHeaderFacetTab
      v-for="(option, index) in conditionOptions"
      :key="`tab${index}`"
      :master="option.master"
      :option="option.option"
      v-model="innerValue"
      class="c-serviceSearchHeaderFacetTabs_tab"
    >
      <span class="c-facetLabel">{{ option.master.name }}</span>
    </ServiceSearchHeaderFacetTab>
  </div>
</template>
<script>
import ServiceSearchHeaderFacetTab from './ServiceSearchHeaderFacetTab'

export default {
  name: 'ServiceSearchHeaderFacetTabs',
  components: {
    ServiceSearchHeaderFacetTab
  },
  props: {
    focusedTabId: {
      type: Number,
      default: null
    },
    conditionOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.focusedTabId
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$labelPadding: 36px;

.c-serviceSearchHeaderFacetTabs {
  display: flex;
  justify-content: flex-start;
  overflow-x: scroll;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &_tab {
    & + & {
      margin-left: 16px;
    }
  }
}
.c-facetLabel {
  max-width: calc(100vw - #{$labelPadding});
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: breakpoint(Search, M)) {
  .c-serviceSearchHeaderFacetTabs {
    padding-left: 12px;
    &::after {
      content: '';
      display: block;
      padding-right: 12px;
    }
    &_tab {
      & + & {
        margin-left: 8px;
      }
    }
  }
}
</style>
